import { render } from "./formula_areas.vue?vue&type=template&id=48e119d4"
import script from "./formula_areas.vue?vue&type=script&lang=js"
export * from "./formula_areas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__